import { attr } from '@ember-data/model';
import BaseModel from 'volta/models/base-model';
import type { IWorkshopIdentityInfo } from './types/workshop';
import { Type } from '@warp-drive/core-types/symbols';

type TSkuLocationStatus = 'ACCEPTED' | 'QC' | 'REJECTED' | 'EXPIRED' | 'UNKNOWN';

export default class SkuLocation extends BaseModel {
  @attr('string') declare skuId: string;
  @attr('number') declare onHand: number;
  @attr('string') declare status: TSkuLocationStatus;
  @attr('string') location?: string;
  @attr('string') zone?: string;
  @attr('string') batchNumber?: string;
  @attr('date') expirationDate?: Date;

  @attr() declare workshopInfo: IWorkshopIdentityInfo;

  [Type] = 'sku-location' as const;
}
